import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.item.Type === _ctx.notificationTypes.Warning || _ctx.item.Type === _ctx.notificationTypes.FeedBack)
      ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 0,
          color: "warning",
          class: "short-icon"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" mdi-alert ")
          ])),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.item.Type === _ctx.notificationTypes.Info)
      ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 1,
          color: "info",
          class: "short-icon"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("mdi-information")
          ])),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.item.Type === _ctx.notificationTypes.Tip)
      ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 2,
          color: "warning",
          class: "short-icon"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("mdi-lightbulb")
          ])),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.item.Type === _ctx.notificationTypes.Kudos)
      ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 3,
          color: "Primary",
          class: "short-icon"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("mdi-thumb-up")
          ])),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}